(()=>{
const BATTEN = window.BATTEN_HOME || {email:'',bands:[],teams:[]};

/* ═══ CONFIG ═══ */
const FORM_ENDPOINT  = "";                            // e.g. "https://formspree.io/f/xxxxxxx"
const FALLBACK_EMAIL = BATTEN.email;
const BANDS = BATTEN.bands;
const COLORS = [
  ["Black","#15171A"],["Navy","#123A5E"],["Royal","#1B4FA8"],["Columbia","#7CB4DE"],
  ["Teal","#0C7C8A"],["Forest","#14472C"],["Maroon","#6B1F2E"],["Red","#C8102E"],
  ["Orange","#E5601F"],["Gold","#E8A317"],["Purple","#4B2A76"],["Silver","#B6BEC2"],
  ["Cream","#EFE8D8"],["White","#F7F8F8"]
];
/* Placeholder teams — swap in your real clients as you deliver them.
   Keep four; each one should eventually get its own /teams/<slug>/ page. */
const TEAMS = BATTEN.teams;

{const _y=document.getElementById("yr"); if(_y)_y.textContent=new Date().getFullYear();}

/* ═══ Mini parka cards ═══ */
function miniParka(t){
  return `<svg viewBox="0 0 120 170" role="img" aria-label="${t.name} custom parka in ${t.sport}">
    <path d="M44 36 C44 12 51 4 60 4 C69 4 76 12 76 36 Z" fill="${t.lining}"/>
    <path d="M44 36 C44 12 51 4 60 4 C69 4 76 12 76 36 L71 36 C71 18 66 11 60 11 C54 11 49 18 49 36 Z" fill="${t.shell}"/>
    <path d="M42 36 L27 41 L21 104 L35 107 L39 57 Z" fill="${t.shell}" stroke="rgba(0,0,0,.3)" stroke-width="1.4"/>
    <path d="M78 36 L93 41 L99 104 L85 107 L81 57 Z" fill="${t.shell}" stroke="rgba(0,0,0,.3)" stroke-width="1.4"/>
    <path d="M42 36 C42 36 48 32 60 32 C72 32 78 36 78 36 L82 160 L38 160 Z" fill="${t.shell}" stroke="rgba(0,0,0,.3)" stroke-width="1.4"/>
    <rect x="38" y="96" width="44" height="7" fill="${t.accent}"/>
    <rect x="21" y="96" width="16" height="8" fill="${t.accent}"/>
    <rect x="83" y="96" width="16" height="8" fill="${t.accent}"/>
    <path d="M49 34 L71 34 L69 41 L60 45 L51 41 Z" fill="${t.lining}"/>
    <line x1="60" y1="40" x2="60" y2="160" stroke="rgba(0,0,0,.4)" stroke-width="2.4" stroke-dasharray="1.5 2.5"/>
  </svg>`;
}
document.getElementById("teamCards").innerHTML = TEAMS.map(t=>
  `<div class="tcard">${miniParka(t)}<b>${t.name}</b><span>${t.sport}</span><div class="det">${t.det}</div></div>`
).join("");

/* ═══ Swatches ═══ */
const picked={shell:"#123A5E",accent:"#C8102E",lining:"#EFEFEF"};
const NAMES ={shell:"Navy",accent:"Red",lining:"Natural"};
document.querySelectorAll(".swatches").forEach(group=>{
  const target=group.dataset.target;
  COLORS.forEach(([name,hex])=>{
    const b=document.createElement("button");
    b.type="button"; b.className="sw"; b.style.background=hex;
    b.title=name; b.setAttribute("aria-label",name);
    b.setAttribute("aria-pressed", picked[target]===hex?"true":"false");
    b.addEventListener("click",()=>{
      picked[target]=hex; NAMES[target]=name;
      group.querySelectorAll(".sw").forEach(s=>s.setAttribute("aria-pressed","false"));
      b.setAttribute("aria-pressed","true"); paint();
    });
    group.appendChild(b);
  });
});
function isLight(hex){
  const r=parseInt(hex.substr(1,2),16),g=parseInt(hex.substr(3,2),16),b=parseInt(hex.substr(5,2),16);
  return (r*299+g*587+b*114)/1000>150;
}
function paint(){
  ["p-hood","p-slv1","p-slv2","p-upper","p-lower"].forEach(id=>document.getElementById(id).setAttribute("fill",picked.shell));
  ["p-stripe","p-cuff1","p-cuff2"].forEach(id=>document.getElementById(id).setAttribute("fill",picked.accent));
  ["p-hoodline"].forEach(id=>document.getElementById(id).setAttribute("fill",picked.lining));
  document.getElementById("p-name").setAttribute("fill", isLight(picked.shell)?"rgba(0,0,0,.78)":"rgba(255,255,255,.94)");
  document.getElementById("f_shell").value=NAMES.shell;
  document.getElementById("f_accent").value=NAMES.accent;
  document.getElementById("f_lining").value=NAMES.lining;
}

/* ═══ Tiles ═══ */
const answers={sport:"",qty:12};
document.querySelectorAll("[data-pick]").forEach(group=>{
  const key=group.dataset.pick;
  group.querySelectorAll(".tile").forEach(t=>{
    t.addEventListener("click",()=>{
      group.querySelectorAll(".tile").forEach(x=>x.setAttribute("aria-pressed","false"));
      t.setAttribute("aria-pressed","true");
      answers[key]= key==="qty" ? parseInt(t.dataset.val) : t.dataset.val;
      if(key==="qty") price();
      document.getElementById("f_"+(key==="qty"?"qty":"sport")).value=answers[key];
      setTimeout(()=>go(step+1),220);
    });
  });
});
function money(n){return "$"+n.toLocaleString("en-US")}
function price(){
  const n=answers.qty||12;
  let band=BANDS[0]; for(const b of BANDS) if(n>=b.min) band=b;
  document.getElementById("unitPrice").innerHTML=money(band.price)+' <small>each</small>';
  document.getElementById("totalPrice").textContent=money(band.price*n);
  document.getElementById("f_unit").value=band.price;
}
document.getElementById("team").addEventListener("input",e=>{
  const v=(e.target.value||"").trim().toUpperCase().slice(0,9);
  document.getElementById("p-name").textContent=v||"NAME";
});

/* ═══ Stepper ═══ */
let step=1; const TOTAL=4;
function go(n){
  if(n<1||n>TOTAL) return; step=n;
  document.querySelectorAll(".qstep").forEach(s=>s.classList.toggle("on",+s.dataset.step===step));
  for(let i=1;i<=TOTAL;i++) document.getElementById("pb"+i).classList.toggle("on",i<=step);
  const f=document.querySelector(".qstep.on input, .qstep.on textarea");
  if(f&&step>2) f.focus({preventScroll:true});
}
document.querySelectorAll("[data-next]").forEach(b=>b.addEventListener("click",()=>{
  if(step===1&&!answers.sport){flash(1);return}
  if(step===2&&!answers.qty){flash(2);return}
  if(step===3&&!document.getElementById("team").value.trim()){document.getElementById("team").reportValidity();return}
  go(step+1);
}));
document.querySelectorAll("[data-back]").forEach(b=>b.addEventListener("click",()=>go(step-1)));
function flash(n){
  document.querySelector('.qstep[data-step="'+n+'"] .tiles')
    .animate([{opacity:1},{opacity:.35},{opacity:1}],{duration:340});
}

/* ═══ Submit ═══ */
document.getElementById("quoteForm").addEventListener("submit",async e=>{
  e.preventDefault();
  const form=e.target;
  if(!form.checkValidity()){form.reportValidity();return}
  const btn=document.getElementById("submitBtn");
  btn.disabled=true; btn.textContent="Sending…";
  if(!FORM_ENDPOINT){
    const d=new FormData(form);
    const body=[...d.entries()].filter(([k])=>k!=="logo")
      .map(([k,v])=>k.replace(/_/g," ")+": "+v).join("\n");
    window.location.href="mailto:"+FALLBACK_EMAIL
      +"?subject="+encodeURIComponent("Parka proof request — "+d.get("team"))
      +"&body="+encodeURIComponent(body);
    btn.disabled=false; btn.textContent="Send my proof request"; return;
  }
  try{
    const res=await fetch(FORM_ENDPOINT,{method:"POST",body:new FormData(form),headers:{Accept:"application/json"}});
    if(!res.ok) throw new Error();
    form.hidden=true;
    const d=document.getElementById("doneMsg"); d.hidden=false; d.scrollIntoView({block:"center"});
  }catch{
    btn.disabled=false; btn.textContent="Send my proof request";
    alert("That didn't send. Email us at "+FALLBACK_EMAIL+" and we'll pick it up from there.");
  }
});

paint(); price(); go(1);

})();